export var lf;
(function (lf) {
    let Order;
    (function (Order) {
        Order[Order["ASC"] = 0] = "ASC";
        Order[Order["DESC"] = 1] = "DESC";
    })(Order = lf.Order || (lf.Order = {}));
    let Type;
    (function (Type) {
        Type[Type["ARRAY_BUFFER"] = 0] = "ARRAY_BUFFER";
        Type[Type["BOOLEAN"] = 1] = "BOOLEAN";
        Type[Type["DATE_TIME"] = 2] = "DATE_TIME";
        Type[Type["INTEGER"] = 3] = "INTEGER";
        Type[Type["NUMBER"] = 4] = "NUMBER";
        Type[Type["STRING"] = 5] = "STRING";
        Type[Type["OBJECT"] = 6] = "OBJECT";
        Type[Type["OBJECT_ARRAY"] = 7] = "OBJECT_ARRAY";
        Type[Type["STRING_ARRAY"] = 8] = "STRING_ARRAY";
        Type[Type["NUMBER_ARRAY"] = 9] = "NUMBER_ARRAY";
    })(Type = lf.Type || (lf.Type = {}));
    let ConstraintAction;
    (function (ConstraintAction) {
        ConstraintAction[ConstraintAction["RESTRICT"] = 0] = "RESTRICT";
        ConstraintAction[ConstraintAction["CASCADE"] = 1] = "CASCADE";
    })(ConstraintAction = lf.ConstraintAction || (lf.ConstraintAction = {}));
    let ConstraintTiming;
    (function (ConstraintTiming) {
        ConstraintTiming[ConstraintTiming["IMMEDIATE"] = 0] = "IMMEDIATE";
        ConstraintTiming[ConstraintTiming["DEFERRABLE"] = 1] = "DEFERRABLE";
    })(ConstraintTiming = lf.ConstraintTiming || (lf.ConstraintTiming = {}));
    let TransactionType;
    (function (TransactionType) {
        TransactionType[TransactionType["READ_ONLY"] = 0] = "READ_ONLY";
        TransactionType[TransactionType["READ_WRITE"] = 1] = "READ_WRITE";
    })(TransactionType = lf.TransactionType || (lf.TransactionType = {}));
    let schema;
    (function (schema) {
        let DataStoreType;
        (function (DataStoreType) {
            DataStoreType[DataStoreType["FIREBASE"] = 0] = "FIREBASE";
            DataStoreType[DataStoreType["INDEXED_DB"] = 1] = "INDEXED_DB";
            DataStoreType[DataStoreType["LOCAL_STORAGE"] = 2] = "LOCAL_STORAGE";
            DataStoreType[DataStoreType["MEMORY"] = 3] = "MEMORY";
            DataStoreType[DataStoreType["WEB_SQL"] = 4] = "WEB_SQL";
        })(DataStoreType = schema.DataStoreType || (schema.DataStoreType = {}));
    })(schema = lf.schema || (lf.schema = {}));
    let op;
    (function (op) {
    })(op = lf.op || (lf.op = {}));
    let fn;
    (function (fn) {
    })(fn = lf.fn || (lf.fn = {}));
})(lf || (lf = {}));
